<template>
  <v-card
    class="pa-5"
    :class="$vuetify.breakpoint.mobile ? 'flex-column pa-3' : 'mr-2 my-4 pa-1'"
    @click="$router.push({ name: 'main.offre-abonnement'})"
  >
    <div class="d-flex justify-center">
      <v-icon
        size="18"
        
        class="align-self-center"
        color="var(--orange-dark)"
      >
        mdi-lock-outline
      </v-icon>
      <div class="align-self-center intro text-gris-fonce mx-4">
        Débloquez les fonctionnalités
      </div>

      <v-icon class="align-self-center pr-3 ">
        mdi-chevron-right
      </v-icon>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'RebondAbonnement',
}
</script>

